(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-link-blocks"] && !Shopify.designMode) return;
  try {
    
  if (!window.JSCImageLinkBlocksAltContent) {
    window.JSCImageLinkBlocksAltContent = true;

    const sectionSelector = '[data-image-link-blocks-section]';

    const normalizePageUrl = (value) => {
      const trimmedValue = value.trim();

      if (!trimmedValue) {
        return '';
      }

      try {
        const parsedUrl = new URL(trimmedValue, window.location.origin);
        const pathname = parsedUrl.pathname.replace(/\/+$/, '') || '/';
        const sortedParams = Array.from(parsedUrl.searchParams.entries()).sort((left, right) => {
          if (left[0] === right[0]) {
            return left[1].localeCompare(right[1]);
          }

          return left[0].localeCompare(right[0]);
        });
        const search = new URLSearchParams(sortedParams).toString();

        return `${pathname}${search ? `?${search}` : ''}`;
      } catch (error) {
        return trimmedValue.replace(window.location.origin, '').replace(/\/+$/, '') || '/';
      }
    };

    const splitMatches = (value) => value.split(',').map(normalizePageUrl).filter(Boolean);
    const currentPageUrl = () => normalizePageUrl(window.location.pathname + window.location.search);

    const resolveSections = (root) => {
      if (root.matches && root.matches(sectionSelector)) {
        return [root];
      }

      return Array.from(root.querySelectorAll(sectionSelector));
    };

    const updateSection = (section) => {
      const alternativeGroups = Array.from(section.querySelectorAll('[data-image-link-blocks-alternative]'));

      if (!alternativeGroups.length) {
        return;
      }

      const defaultItems = Array.from(section.querySelectorAll('[data-image-link-blocks-default]'));
      const activePageUrl = currentPageUrl();
      let hasMatch = false;

      alternativeGroups.forEach((group) => {
        const matches = splitMatches(group.dataset.pageUrls || '');
        const isMatch = matches.includes(activePageUrl);

        group.hidden = !isMatch;

        if (isMatch) {
          hasMatch = true;
        }
      });

      defaultItems.forEach((item) => {
        item.hidden = hasMatch;
      });
    };

    const updateAllSections = (root = document) => {
      resolveSections(root).forEach(updateSection);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => updateAllSections());
    } else {
      updateAllSections();
    }

    document.addEventListener('shopify:section:load', (event) => updateAllSections(event.target));
    window.addEventListener('popstate', () => updateAllSections());
  }

  } catch(e) { console.error(e); }
})();
})();
